export default ({...props}) => {
  const {space, size, borderColor} = props.theme
  return `
  &.MuiListItem-root{
    padding:0px;


    .MuiListItemAvatar-root{
      padding: 0px ${space(1)}px 0 0;
    }

    .MuiAvatar-root{
      width:${size(11.625)}px;
      height:${size(10.75)}px;
      background:transparent;

      & img {
        width:${size(11.625)}px;
        height:${size(10.75)}px;
      }

      & [ap_atom_name="svgIconAtom"]{
        height:${size(10.75)}px;
        display: -webkit-box;
        > svg {
          width: ${size(12.5)}%;
        }
      }
    }

    & [ahd_type="product"] {
      padding:0px 0px ${size(1)}px 0px;
    }

    & [ahd_type="regText"] {
      padding:${size(1)}px 0px 0px 0px;
    }

    &>.MuiListItemText-root {
      margin-left:${space(1)}px;
    }

    .MuiDivider-root {
      padding:0px;
      width: 100%;
      background-color:${borderColor.main};
    }

    .product-title {
      width:100%;
      padding-left:${space(1)}px;
    }

    .service-string-wrapper {
      margin-left:${space(1)}px;
      flex: 1
    }

    .product-details-wrapper{
      display: flex;
    }
    .product-quantity-wrapper:after{
      content: ": ";
      margin-left: ${space(1)}px;
    }
    
    .service-string-wrapper:after {
      content: ", ";
    }
    .service-string-wrapper:last-child:after{
      content: "";
    }
  }
  `
}
